import http from "../util/http";

const modules = `sy`;

const modulesCt = "ct";

export default {
  milestonePage: data => http.get(`${modulesCt}/milestone/list`, data), // 企业里程碑
  recruitList: data => http.get(`${modulesCt}/recruit/list`, data), // 招聘记录
  honoraryList: data => http.get(`${modulesCt}/honorary/list`, data), // 资质列表
  counselAdd: data => http.post(`${modulesCt}/counsel/add`, data), // 

};